import { useRef } from 'react';

/** Holds the latest value without changing ref identity — for stable effects when parent passes new function refs each render. */
export function useLatestRef<T>(value: T) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
